import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { serviceGroups } from "@/mocks/services";
import { site } from "@/mocks/site";

export default function ServicesSection() {
  return (
    <section id="hizmetler" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Hizmetlerimiz"
            title="Diş hekiminizin istediği tüm görüntülemeler"
            description="İster 2D panoramik ya da sefalometrik, ister 3D tomografi — hepsini dijital ortamda, aynı gün raporlu olarak teslim ediyoruz."
          />
        </Reveal>

        <div className="mt-16 flex flex-col gap-16">
          {serviceGroups.map((group, groupIndex) => (
            <div key={group.id}>
              <Reveal>
                <div className="flex flex-col gap-4 border-t border-background-300 pt-7 md:flex-row md:items-end md:justify-between">
                  <div className="flex items-start gap-4">
                    <span className="font-heading text-2xl font-medium text-accent-600">
                      0{groupIndex + 1}
                    </span>
                    <div>
                      <h3 className="font-heading text-2xl font-medium tracking-tight text-foreground-950 md:text-3xl">
                        {group.label}
                      </h3>
                      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                        {group.caption}
                      </p>
                    </div>
                  </div>
                  <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-semibold text-foreground-700">
                    <i className="ri-layout-grid-line text-sm text-primary-600" aria-hidden="true" />
                    {group.items.length} yöntem
                  </span>
                </div>
              </Reveal>

              <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {group.items.map((item, index) => (
                  <Reveal key={item.slug} delay={index * 60}>
                    <article className="group relative flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300">
                      <span
                        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                        aria-hidden="true"
                      />
                      <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 ring-1 ring-inset ring-primary-300/60 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                        <i className={`${item.icon} text-xl`} aria-hidden="true" />
                      </span>
                      <h4 className="mt-5 font-heading text-lg font-medium tracking-tight text-foreground-950">
                        {item.title}
                      </h4>
                      <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                        {item.summary}
                      </p>
                      <div className="mt-6 flex items-center justify-between gap-3 border-t border-background-200 pt-4">
                        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-foreground-600">
                          <i className="ri-time-line text-sm text-primary-600" aria-hidden="true" />
                          {item.duration}
                        </span>
                        <a
                          href={`${site.whatsappBase}${encodeURIComponent(
                            `Merhaba, ${item.title} çekimi için bilgi ve randevu almak istiyorum.`,
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex cursor-pointer items-center gap-1 text-xs font-semibold text-primary-700 transition-colors hover:text-primary-500"
                        >
                          Bu çekim için yaz
                          <i className="ri-arrow-right-up-line text-sm" aria-hidden="true" />
                        </a>
                      </div>
                    </article>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>

        <Reveal>
          <div className="relative mt-14 flex flex-col items-center justify-between gap-5 overflow-hidden rounded-xl border border-primary-200 bg-primary-100/60 px-6 py-6 md:flex-row md:px-8">
            <span
              className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
              aria-hidden="true"
            />
            <div className="flex items-start gap-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-question-line text-xl" aria-hidden="true" />
              </span>
              <div>
                <h3 className="font-heading text-lg font-medium text-foreground-950">
                  Hangi filmi çektirmem gerektiğinden emin değil misiniz?
                </h3>
                <p className="mt-1 text-sm text-foreground-600">
                  Diş hekiminizin istediği çekimi söyleyin; WhatsApp'tan hemen yönlendirelim.
                </p>
              </div>
            </div>
            <a
              href={`${site.whatsappBase}${encodeURIComponent(
                "Merhaba, diş hekimim hangi filmi çektirmem gerektiğini söyledi; yardımcı olur musunuz?",
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-fit shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              WhatsApp'tan Sor
            </a>
          </div>
        </Reveal>

        <p className="mt-8 text-center text-xs text-foreground-500">
          {site.name} · {site.address}
        </p>
      </div>
    </section>
  );
}